import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import CommissionPcAsmItem from 'src/models/personnel/CommissionPcAsmItem';

interface IPcAsmTotalsDialogProps {
    dialogName: string;
    items: Array<CommissionPcAsmItem>;
    onClose: () => void;
}

const formatCurrency = (value: number) =>
    (value ?? 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

// Mirrors manager_commission.fmt's "PC/ASM Totals" window (canvas/window PCAPM) - a flat,
// scrollable list of PC_TSD_NO/AKA_NAME/PC_AMT for whichever manager/period is currently in the
// search bar, plus a grand total. Available in both Admin/Accounting Admin and manager-scope mode,
// matching Oracle's own button (reads whichever manager is in :control.tsd_no regardless of who's
// logged in).
const PcAsmTotalsDialog = (props: IPcAsmTotalsDialogProps) => {
    const total = props.items.reduce((sum, item) => sum + (item.pcAmt ?? 0), 0);

    return (
        <Dialog title="PC/ASM Totals" dialogName={props.dialogName} bodyStyle={{ width: '45%' }} isExitButtonInvisible={true}>
            <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                <thead>
                    <tr>
                        <th className="table-header" colSpan={2} style={{ textAlign: 'center' }}>DLC Personnel</th>
                        <th className="table-header" style={{ textAlign: 'center' }}>PC/ASM Bonus</th>
                    </tr>
                    <tr>
                        <th className="table-header" style={{ width: '25%' }}>TSD_NO</th>
                        <th className="table-header" style={{ width: '45%' }}>AKA_NAME</th>
                        <th className="table-header" style={{ width: '30%' }}>PC_AMT</th>
                    </tr>
                </thead>
            </table>
            <div style={{ maxHeight: '40vh', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                    <tbody>
                        {props.items.length === 0 && (
                            <tr>
                                <td colSpan={3} style={{ textAlign: 'center', padding: '1rem' }}>No PC/ASM bonus records for this manager/period.</td>
                            </tr>
                        )}
                        {props.items.map((item) => (
                            <tr key={item.tsdNo}>
                                <td style={{ width: '25%' }}>{item.tsdNo}</td>
                                <td style={{ width: '45%' }}>{item.akaName}</td>
                                <td style={{ width: '30%' }}>{formatCurrency(item.pcAmt)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="button-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1rem' }}>
                <Button className="blue-hover-button" style={{ width: '10rem' }} text="OK" onClick={() => props.onClose()} />
                <span style={{ backgroundColor: '#8ee88e', padding: '.5rem 1rem', borderRadius: '4px', fontWeight: 'bold' }}>
                    Total: {formatCurrency(total)}
                </span>
            </div>
        </Dialog>
    );
};

export default PcAsmTotalsDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/PcAsmTotalsDialog.tsx